export class AppConfig {
    clientID = '';
    authority = '';
    tenant = '';
    applicationInsightsKey = '';
    storageUri = '';
    public static GLOBAL_CONFIG:AppConfig;
}
